import React, { useState } from 'react';
import Modal from 'components/Modal';
import { PicturesContainer, Picture, BigPicture } from './styles';

const ServicesPicProModal = ({ isOpen, toggle, proPortfolio }) => {
  const [openedPicture, setOpenedPicture] = useState(false);
  const [active, setActive] = useState(false);

  const openPicture = (photo) => {
    setOpenedPicture(photo);

    setTimeout(() => {
      setActive(true);
    }, 400);
  };

  const closePicture = () => {
    setOpenedPicture(false);
    setActive(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => (openedPicture ? closePicture() : toggle())}
      title={openedPicture ? openedPicture.description : 'Fotos de outros serviços'}
      width="800px"
    >
      <PicturesContainer
        onClick={() => {
          if (openedPicture) return closePicture();
        }}
      >
        {openedPicture ? (
          <BigPicture className={active ? 'active' : ''}>
            <img src={openedPicture.url} alt="big service image" />
          </BigPicture>
        ) : (
          proPortfolio && proPortfolio.length > 0 && proPortfolio.map(photo => (
            <Picture key={photo.id} src={photo.url_thumb} onClick={() => openPicture(photo)} />
          ))
        )}
      </PicturesContainer>
    </Modal>
  );
};

export default ServicesPicProModal;
